"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFulfilledValue = void 0;
/**
 * Check if a promise is fulfilled and return its value.
 *
 * @param result
 * @param defaultValue
 */
const getFulfilledValue = (result, defaultValue) => result.status === 'fulfilled' ? result.value : defaultValue ?? null;
exports.getFulfilledValue = getFulfilledValue;
//# sourceMappingURL=getFulfiledValue.js.map